'use client';

import { Suspense } from 'react';

import { PopupPageContent } from './PopupPageContent';

export const PopupPage = () => {
	return (
		<Suspense>
			<PopupPageContent />
		</Suspense>
	);
};
